<h1>{{ currentTitle }}</h1>

<app-league></app-league>

<form class="form" [formGroup]="registerPlayerForm" (ngSubmit)="onSubmit()" autocomplete="off">

  <span><span class="primary">*</span> {{ 'teams.sign_up.mandatory_indicator' | translate }}</span>

  <div class="form-group mt-40">
    <label for="email">{{ 'teams.player_registration.email' | translate }} *</label>
    <input id="email" nbInput type="text" formControlName="email">
    @if(registerPlayerForm.controls['email']['invalid'] &&
    (registerPlayerForm.controls['email'].touched || registerPlayerForm.controls['email'].dirty)) {
      @if(registerPlayerForm.controls['email'].errors?.['required']) {
        <span class="error-message">{{ 'common.mandatory' | translate }}</span>
      }
    }
  </div>

  <div class="form-group">
    <label for="password">{{ 'teams.player_registration.password' | translate }} *</label>
    <input id="password" nbInput type="password" formControlName="password" autocomplete="new-password" />
    @if(registerPlayerForm.controls['password']['invalid'] && (registerPlayerForm.controls['password'].touched || registerPlayerForm.controls['password'].dirty)) {
      @if(registerPlayerForm.controls['password'].errors?.['required']) {
        <span class="error-message">{{ 'common.mandatory' | translate }}</span>
      }
    }
  </div>

  <div class="form-group">
    <label for="password_confirmation">{{ 'teams.player_registration.confirm_password' | translate }} *</label>
    <input id="password_confirmation" nbInput type="password" formControlName="password_confirmation">
    @if(registerPlayerForm.controls['password_confirmation']['invalid'] && (registerPlayerForm.controls['password_confirmation'].touched || registerPlayerForm.controls['password_confirmation'].dirty)) {
      @if(registerPlayerForm.controls['password_confirmation'].errors?.['required']) {
        <span class="error-message">{{ 'common.mandatory' | translate }}</span>
      }
    }
    @if(registerPlayerForm.errors?.['mismatch'] && registerPlayerForm.controls['password_confirmation'].dirty) {
      <span class="error-message">{{ 'teams.player_registration.mismatch' | translate }}</span>
    }
  </div>

  @if(! isCaptainSigningUp) {
    <div class="form-group">
      <label for="team_player_id">{{ 'teams.player_registration.activision_id' | translate }} *</label>
      <nb-select id="team_player_id" name="team_player_id" formControlName="team_player_id">
        @for (activisionId of activisionIds(); track activisionId.team_player_id) {
          <nb-option [value]="activisionId.team_player_id">{{activisionId.account_activision}}</nb-option>
        }
      </nb-select>
      @if(registerPlayerForm.controls['team_player_id']['invalid'] && (registerPlayerForm.controls['team_player_id'].touched || registerPlayerForm.controls['team_player_id'].dirty)) {
        @if(registerPlayerForm.controls['team_player_id'].errors?.['required']) {
          <span class="error-message">{{ 'common.mandatory' | translate }}</span>
        }
      }
    </div>
  }

  <div class="form-navbar mt-40">
    <a class="simple-button" (click)="createTicket()">{{ 'teams.player_registration.create_ticket' | translate }}</a>
    <button class="app-button" type="submit" [disabled]="registerPlayerForm['invalid']">{{ 'teams.player_registration.create_account' | translate }}</button>
  </div>
</form>

<div class="mt-50"></div>

<app-contact [hideTitle]="true"></app-contact>
